import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, MapPin, Camera } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0D1B2A] text-white/90 mt-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center ring-1 ring-[#D4AF37]/60">
              <Camera size={20} className="text-[#D4AF37]" />
            </div>
            <div>
              <div className="font-display text-2xl">Eterniza</div>
              <div className="font-script text-[#D4AF37] -mt-1">imãs</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed">
            Presentes personalizados que eternizam histórias. Cada peça é feita com carinho e atenção aos detalhes.
          </p>
        </div>

        <div>
          <div className="eyebrow text-[#D4AF37]">Loja</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/catalogo" className="hover:text-[#D4AF37]">Catálogo completo</Link></li>
            <li><Link to="/catalogo?c=chaveiros" className="hover:text-[#D4AF37]">Chaveiros NFC</Link></li>
            <li><Link to="/catalogo?c=imas" className="hover:text-[#D4AF37]">Imãs de foto</Link></li>
            <li><Link to="/catalogo?c=botons" className="hover:text-[#D4AF37]">Botons</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-[#D4AF37]">Atendimento</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/agendar" className="hover:text-[#D4AF37]">Agendar sessão</Link></li>
            <li><Link to="/contato" className="hover:text-[#D4AF37]">Fale conosco</Link></li>
            <li><Link to="/sobre" className="hover:text-[#D4AF37]">Sobre nós</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-[#D4AF37]">Contatos</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <MessageCircle size={16} className="text-[#D4AF37]" />
              <a href="https://wa.me/5542984285953" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">(42) 98428-5953 · Karine</a>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle size={16} className="text-[#D4AF37]" />
              <a href="https://wa.me/5542984210960" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">(42) 98421-0960 · Ayran</a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram size={16} className="text-[#D4AF37]" />
              <a href="https://instagram.com/eternizaimas" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">@eternizaimas</a>
            </li>
            <li className="flex items-center gap-2 text-white/60">
              <MapPin size={16} className="text-[#D4AF37]" /> Envios para todo o Brasil
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Eterniza Imãs · eternizaimas.com.br</div>
          <div className="font-script text-[#D4AF37] text-lg">Momentos que você vê. Histórias que você revive.</div>
        </div>
      </div>
    </footer>
  );
}
